import AccessTimeIcon from "@mui/icons-material/AccessTime";
import CancelIcon from "@mui/icons-material/Cancel";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import RestartAltIcon from "@mui/icons-material/RestartAlt";
import { Box, Button, CircularProgress, Divider, Grid, Paper, styled, Typography } from "@mui/material";
import React from "react";
import { useNavigate } from "react-router-dom";

const ExamResults = ({ score, examInfo, timeRemaining, formatTime, handleTryAgain }) => {
  const navigate = useNavigate();
  const isPassed = score.passed;
  const timeUsed = examInfo.timeLimit * 60 - timeRemaining;
  const totalTime = examInfo.timeLimit * 60;

  return (
    <Paper className="result-paper" elevation={3}>
      <Box className="result-accent" sx={{ bgcolor: isPassed ? "success.main" : "error.main" }} />

      <Typography variant="h4" className="result-title">
        Exam Results
      </Typography>

      <Grid container spacing={4}>
        <Grid item xs={12} sm={5} className="gauge-container">
          <Box className="gauge-wrapper">
            <Box className="gauge">
              <CircularProgress variant="determinate" value={100} size={180} thickness={4} className="gauge-background" />
              <CircularProgress
                variant="determinate"
                value={score.percentage}
                size={180}
                thickness={4}
                className="gauge-progress"
                sx={{ color: isPassed ? "success.main" : "error.main" }}
              />
              <Box className="gauge-content">
                <Typography variant="h4" className="gauge-percentage">
                  {score.percentage}%
                </Typography>
                <Typography variant="body2" className="gauge-label">
                  Score
                </Typography>
              </Box>
            </Box>

            <Box className="result-status">
              {isPassed ? <CheckCircleIcon color="success" className="status-icon" /> : <CancelIcon color="error" className="status-icon" />}
              <Typography variant="h6" className="status-text" sx={{ color: isPassed ? "success.main" : "error.main" }}>
                {isPassed ? "PASSED" : "FAILED"}
              </Typography>
            </Box>
          </Box>
        </Grid>

        <Grid item xs={12} sm={7}>
          <Box className="details-container">
            <Typography variant="h6" className="details-title">
              Exam Statistics
            </Typography>

            <Box className="details-box">
              <Box className="details-row">
                <Typography variant="body1" className="details-label">
                  Passing Mark:
                </Typography>
                <Typography variant="body1" className="details-value">
                  {examInfo.passingMarks}%
                </Typography>
              </Box>

              <Box className="details-row">
                <Typography variant="body1" className="details-label">
                  Your Score:
                </Typography>
                <Typography variant="body1" className="details-score-value" sx={{ color: isPassed ? "success.main" : "error.main" }}>
                  {score.percentage}%
                </Typography>
              </Box>

              <Divider className="details-divider" />

              <Box className="time-info">
                <AccessTimeIcon fontSize="small" className="time-icon" />
                <Typography variant="body2" className="time-text">
                  Time used: {formatTime(timeUsed)} of {formatTime(totalTime)}
                </Typography>
              </Box>

              {score.message && (
                <Box
                  className="message-box"
                  sx={{
                    bgcolor: isPassed ? "success.lighter" : "error.lighter",
                    borderColor: isPassed ? "success.light" : "error.light",
                  }}
                >
                  <Typography variant="body2" className="message-text">
                    {score.message}
                  </Typography>
                </Box>
              )}
            </Box>
          </Box>
        </Grid>
      </Grid>

      <Box className="button-container">
        <Button variant="contained" startIcon={<RestartAltIcon />} onClick={handleTryAgain} className="retry-button">
          Try Again
        </Button>
        <Button
          variant="contained"
          onClick={() => {
            navigate(`/course/${examInfo.courseId}`);
          }}
          className="retry-button"
        >
          Back to Course
        </Button>
      </Box>
    </Paper>
  );
};

export default ExamResults;
